import * as Yup from 'yup';

export const regionRules = {
    name: Yup.string().required('Campo obrigatório'),
    states: Yup.string().required('Campo obrigatório'),
};

export default regionRules;
